interface Props {
  score: number;
  size?: number;
}

const GRADE_COLOR: Record<string, string> = {
  A: '#2e7d32',
  B: '#388e3c',
  C: '#f57c00',
  D: '#e64a19',
  F: '#c62828',
};

function grade(score: number): string {
  if (score >= 90) return 'A';
  if (score >= 75) return 'B';
  if (score >= 55) return 'C';
  if (score >= 35) return 'D';
  return 'F';
}

function scoreColor(score: number): string {
  return GRADE_COLOR[grade(score)] ?? '#9e9e9e';
}

export default function ScoreCircle({ score, size = 100 }: Props) {
  const radius = (size - 10) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;
  const color = scoreColor(score);

  return (
    <div
      className="asneris-score-circle"
      style={{ width: size, height: size }}
      aria-label={`Score: ${score} out of 100`}
    >
      <svg width={size} height={size}>
        {/* Track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#e0e0e0"
          strokeWidth={8}
        />
        {/* Progress */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={8}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dashoffset 0.6s ease' }}
        />
      </svg>
      <div className="asneris-score-circle__label" style={{ color }}>
        {score}
        <span>/100</span>
      </div>
    </div>
  );
}
